import { createPortal } from 'react-dom';
import { Button } from '../../components/Button';
import { Modal } from '../../components/Modal';
import { Actions, Message } from './ConfirmModal.styles';
import type { ConfirmModalProps } from './ConfirmModal.types';

export function ConfirmModal({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  labels = {},
}: ConfirmModalProps) {
  const { confirm = 'Confirm', cancel = 'Cancel', close = 'Close' } = labels;

  const footer = (
    <Actions>
      <Button variant="primary" size="large" fullWidth type="button" onClick={onConfirm}>
        {confirm}
      </Button>
      <Button variant="outline" size="large" fullWidth type="button" onClick={onCancel}>
        {cancel}
      </Button>
    </Actions>
  );

  if (!open || typeof document === 'undefined') return null;

  return createPortal(
    <Modal open={open} onClose={onCancel} title={title} footer={footer} labels={{ close }}>
      <Message>{message}</Message>
    </Modal>,
    document.body
  );
}
